type Props = {
  color: string;
};

const HorizontalBreak = ({ color }: Props) => {
  return (
    <hr
      className="mx-auto my-50"
      style={{
        color,
        backgroundColor: color,
        height: 2,
        borderRadius: '10px',
        width: '85%',
      }}
    />
  );
};

export default HorizontalBreak;
